// utils to delay promise
function wait(ms) {
    return (x) => {
        return new Promise(resolve => setTimeout(() => resolve(x), ms));
    };
}

function normalizeTextUppercase(value) {
    if (value === null || value === undefined) {
        return value;
    }

    return String(value).toLocaleUpperCase("pt-BR");
}

function normalizeFieldsUppercase(target, fields) {
    if (!target) {
        return target;
    }

    fields.forEach((field) => {
        if (Object.prototype.hasOwnProperty.call(target, field)) {
            target[field] = normalizeTextUppercase(target[field]);
        }
    });

    return target;
}

function normalizeItemsUppercase(items, fields) {
    if (!Array.isArray(items)) {
        return items;
    }

    return items.map((item) => normalizeFieldsUppercase({ ...item }, fields));
}

function normalizeNullableInteger(value) {
    if (value === null || value === undefined) {
        return null;
    }

    if (typeof value === "string" && value.trim() === "") {
        return null;
    }

    const numericValue = Number(value);
    return Number.isFinite(numericValue) ? parseInt(numericValue, 10) : value;
}

function normalizeNullableIntegerFields(target, fields) {
    if (!target) {
        return target;
    }

    fields.forEach((field) => {
        if (Object.prototype.hasOwnProperty.call(target, field)) {
            target[field] = normalizeNullableInteger(target[field]);
        }
    });

    return target;
}

function normalizeItemsNullableIntegerFields(items, fields) {
    if (!Array.isArray(items)) {
        return items;
    }

    return items.map((item) => normalizeNullableIntegerFields({ ...item }, fields));
}

export {
    wait,
    normalizeTextUppercase,
    normalizeFieldsUppercase,
    normalizeItemsUppercase,
    normalizeNullableInteger,
    normalizeNullableIntegerFields,
    normalizeItemsNullableIntegerFields,
}